/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMapExclamation = createReactComponent("map-exclamation", "IconMapExclamation", [
  ["path", { d: "M15 20l-6 -3l-6 3v-13l6 -3l6 3l6 -3v8.5", key: "svg-0" }],
  ["path", { d: "M9 4v13", key: "svg-1" }],
  ["path", { d: "M15 7v13", key: "svg-2" }],
  ["path", { d: "M19 16v3", key: "svg-3" }],
  ["path", { d: "M19 22v.01", key: "svg-4" }]
]);

export { IconMapExclamation as default };
//# sourceMappingURL=IconMapExclamation.js.map
